(function () {
  var supportedProducts = ['/products/viaim-recdot', '/products/viaim-opennote'];
  var isSupportedProduct = supportedProducts.some(function (path) {
    return window.location.pathname.includes(path);
  });
  if (!isSupportedProduct) return;

  var NAV_ID = 'viaim-product-media-tabs';
  var STYLE_ID = 'viaim-product-media-tabs-style';

  var tabs = [
    { key: 'products', label: 'Products', prefix: 'products' },
    { key: 'scenarios', label: 'Scenarios', prefix: 'scenarios' },
    { key: 'video', label: 'Video', prefix: 'video' }
  ];

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.viaim-media-tabs{display:inline-flex;align-items:center;justify-content:center;align-self:center;gap:6px;width:auto;max-width:100%;margin:18px auto 2px;padding:7px;background:#f5f5f7;border-radius:24px;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch;}',
      '.viaim-media-tabs::-webkit-scrollbar{display:none;}',
      '.viaim-media-tabs__button{appearance:none;border:0;background:transparent;color:#5f5f63;font:inherit;font-size:14px;font-weight:600;line-height:1;white-space:nowrap;padding:9px 18px;border-radius:999px;cursor:pointer;text-decoration:none;transition:background .18s ease,color .18s ease,box-shadow .18s ease;}',
      '.viaim-media-tabs__button[aria-pressed="true"]{background:#1d1d1f;color:#fff;box-shadow:0 1px 2px rgba(0,0,0,.12);}',
      '@media (max-width: 749px){.viaim-media-tabs{display:flex;width:max-content;max-width:100%;margin-top:14px;padding:6px;gap:4px;border-radius:22px;}.viaim-media-tabs__button{font-size:13px;padding:8px 13px;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function bySelector(selectors, root) {
    for (var i = 0; i < selectors.length; i += 1) {
      var node = (root || document).querySelector(selectors[i]);
      if (node) return node;
    }
    return null;
  }

  function getGalleryContainer() {
    return bySelector([
      '.product__gallery-container',
      'media-gallery',
      '[id^="ProductGallery-"]',
      '.product__media-wrapper',
      '.product__gallery'
    ]);
  }

  function insertAfterGallery(nav, container) {
    var gallery = container.matches('media-gallery') ? container : container.querySelector('media-gallery');
    if (gallery && gallery.parentNode) {
      gallery.insertAdjacentElement('afterend', nav);
      return true;
    }

    container.insertAdjacentElement('beforeend', nav);
    return true;
  }

  function cleanText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mediaCandidates() {
    var gallery = bySelector(['media-gallery', '[id^="ProductGallery-"]']);
    if (!gallery) return [];

    var media = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
    var seen = {};
    return media.filter(function (item) {
      var id = item.getAttribute('data-media-id');
      // Shopify marks non-active slides as hidden, but they are still valid
      // gallery media. Do not filter them out or category tabs have no target.
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function candidateText(item) {
    var text = [
      item.getAttribute('aria-label'),
      item.getAttribute('data-media-type'),
      item.getAttribute('data-media-id')
    ];

    Array.prototype.slice.call(item.querySelectorAll('img, video, source')).forEach(function (node) {
      text.push(node.getAttribute('alt'));
      text.push(node.getAttribute('src'));
      text.push(node.getAttribute('currentSrc'));
      text.push(node.getAttribute('poster'));
    });

    return cleanText(text.join(' '));
  }

  function explicitCategory(item) {
    var nodes = [item].concat(Array.prototype.slice.call(item.querySelectorAll('img, video, source')));
    for (var i = 0; i < nodes.length; i += 1) {
      var alt = nodes[i].getAttribute && nodes[i].getAttribute('alt');
      var match = String(alt || '').match(/^\s*\[(products|scenarios|video)\](?:\s|$)/i);
      if (match) return match[1].toLowerCase();
    }
    return '';
  }

  function isVideoMedia(item) {
    return item.matches('video, deferred-media, external-video') ||
      !!item.querySelector('video, deferred-media, external-video, .play-button') ||
      cleanText(item.getAttribute('data-media-type')).includes('video');
  }

  function scoreCandidate(item, tab) {
    var category = explicitCategory(item);
    if (category === tab.prefix) return 100;
    if (tab.key === 'video' && !category && isVideoMedia(item)) return 80;
    return 0;
  }

  function clickMedia(item) {
    if (!item) return false;

    applyMediaAspect(item);

    var id = item.getAttribute('data-media-id');
    var escapedId = window.CSS && CSS.escape ? CSS.escape(id) : String(id).replace(/"/g, '\\"');
    var thumbnail = id ? document.querySelector('media-dots [data-media-id="' + escapedId + '"]') : null;
    var clickable = thumbnail || item;

    try {
      // The theme's media gallery owns the state transition; click its native
      // thumbnail whenever available instead of relying on a hidden slide.
      clickable.click();
    } catch (error) {
      // A scroll fallback is enough if the gallery component rejects synthetic clicks.
    }

    item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    return true;
  }

  function mediaType(item) {
    return cleanText(item && item.getAttribute('data-media-type'));
  }

  function naturalRatioFromImage(item) {
    var image = item && item.querySelector('img');
    if (!image) return null;

    var width = image.naturalWidth || parseFloat(image.getAttribute('width'));
    var height = image.naturalHeight || parseFloat(image.getAttribute('height'));
    if (!width || !height) return null;

    return width / height;
  }

  function naturalRatioFromVideo(item) {
    var video = item && item.querySelector('video');
    if (!video) return null;

    var width = video.videoWidth || parseFloat(video.getAttribute('width'));
    var height = video.videoHeight || parseFloat(video.getAttribute('height'));
    if (!width || !height) return null;

    return width / height;
  }

  function applyMediaAspect(item) {
    var gallery = bySelector(['media-gallery', '[id^="ProductGallery-"]']);
    var section = gallery && gallery.closest('[id^="shopify-section-"]');
    if (!section || !item) return;

    var ratio = mediaType(item).includes('video') ? naturalRatioFromVideo(item) : naturalRatioFromImage(item);
    if (!ratio && mediaType(item).includes('video')) ratio = 16 / 9;
    if (!ratio) return;

    section.style.setProperty('--aspect-ratio', ratio.toFixed(4));
  }

  function findBestMedia(tab) {
    var candidates = mediaCandidates();
    var best = null;
    var bestScore = -Infinity;

    candidates.forEach(function (item) {
      var score = scoreCandidate(item, tab);
      if (score > bestScore) {
        bestScore = score;
        best = item;
      }
    });

    if (bestScore <= 0) return null;
    return best;
  }

  function setActive(key) {
    var nav = document.getElementById(NAV_ID);
    if (!nav) return;

    Array.prototype.slice.call(nav.querySelectorAll('[data-viaim-media-tab]')).forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-viaim-media-tab') === key ? 'true' : 'false');
    });
  }

  function activate(tab) {
    setActive(tab.key);

    if (tab.key === 'video') {
      var videoMedia = findBestMedia(tab);
      clickMedia(videoMedia);
      return;
    }

    clickMedia(findBestMedia(tab));
  }

  function createNav() {
    var nav = document.createElement('nav');
    nav.id = NAV_ID;
    nav.className = 'viaim-media-tabs';
    nav.setAttribute('aria-label', 'Product media categories');

    tabs.forEach(function (tab, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'viaim-media-tabs__button';
      button.textContent = tab.label;
      button.setAttribute('data-viaim-media-tab', tab.key);
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      button.setAttribute('data-media-category', tab.prefix);
      button.addEventListener('click', function () {
        activate(tab);
      });
      nav.appendChild(button);
    });

    return nav;
  }

  function mount() {
    if (document.getElementById(NAV_ID)) return true;

    var container = getGalleryContainer();
    if (!container) return false;

    addStyles();
    insertAfterGallery(createNav(), container);
    applyMediaAspect(mediaCandidates()[0]);
    return true;
  }

  function boot() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (mount() || attempts > 20) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
